<template>
  <div id="btn-consulte" @click="btnClick">
    <div class="btn-arrow">
      <i v-if="!flip" class="material-icons icon-btn">keyboard_arrow_left</i>
      <i v-else class="material-icons icon-btn">keyboard_arrow_right</i>
    </div>
    <h6 class="lbl-consulte">Consulte</h6>
  </div>
</template>

<script>
  export default {
    name: 'BtnConsulte',
    props: { flip: { type: Boolean, default: false } },
    methods: {
      btnClick() {
        this.$emit("click")
      }
    }
  }
</script>

<style scoped lang="scss">
  $tam-btn: 60px;

  #btn-consulte {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .lbl-consulte {
    font-size: 10pt;
    margin-top: 5px;
    font-weight: 600;
  }

  .btn-arrow {
    cursor: pointer;
    display: flex;
    width: $tam-btn;
    justify-content: center;
    align-items: center;
    height: $tam-btn;
    border: 4px solid #212121;
    transition: 250ms;

    .icon-btn {
      font-size: $tam-btn - 8px;
      color: #212121;
    }

    &:hover {
      background-color: #e4e4e4;
    }

    &:active {
      background-color: #bebebe;
    }
  }
</style>